import styled from "styled-components";
import { responsive } from "../../../utils/style";

const Spacer = styled.div`
  margin-top: 58px;

  ${responsive.md`
    margin-top: 70px;
  `}
`;

export default Spacer;
